let oldScrollY = window.scrollY;

function handleShowHeader() {
  const headerSection = document.getElementsByClassName("header")[0];
  if (
    window.scrollY == 0 &&
    location.href.replace(window.location.origin, "") == "/"
  ) {
    headerSection.style.boxShadow = "none";
  } else if (oldScrollY < window.scrollY && window.scrollY > 0) {
    headerSection.style.translate = `0px ${-1 * headerSection.offsetHeight}px`;
  } else {
    headerSection.style.translate = `0px 0px`;
    headerSection.style.boxShadow = "0 1px rgb(223, 223, 223)";
  }
  oldScrollY = window.scrollY;
}

function addSpinner() {
  const whatsappIconContainer = document.getElementById("chat-bubble");
  const whatsappIcon = document.getElementById("whatsapp-link");
  whatsappIcon.style.display = "none";
  const htmlString = `
  <div style="cursor: pointer;" class="dropping-soon open-prebook-popup">
      <img  src="https://cdn.shopify.com/s/files/1/0872/7776/4886/files/DSFinalHD.gif?v=1721660283"/>
  </div>`;
  var spinner = document.createElement("div");
  spinner.innerHTML = htmlString.trim();
  whatsappIconContainer.appendChild(spinner);
}

function addPopupEventListener() {
  var elements = document.getElementsByClassName("open-prebook-popup");

  for (var i = 0; i < elements.length; i++) {
    elements[i].addEventListener("click", () => {
      let popupButtons = document.getElementsByClassName(
        "ecomsend__Popover__Widget__Text"
      );
      popupButtons[0].click();
    });
  }
}

function replaceAllBlogs() {
  let tabs = document.getElementsByClassName("tablink");
  for (let i = 0; i < tabs.length; i++) {
    if (tabs[i].innerHTML.includes("All Blogs")) {
      tabs[i].innerHTML = tabs[i].innerHTML.replace("All Blogs", "All");
    }
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  if (
    location.href.replace(window.location.origin, "") == "/" &&
    window.innerWidth > 765
  ) {
    handleShowHeader();
    window.addEventListener("scroll", handleShowHeader);
  }
  addPopupEventListener();
  replaceAllBlogs();
});
